module.exports = __webpack_public_path__ + "img/Sensor_Height.3376e406.png";